// extracted by mini-css-extract-plugin
export default {"tableItem":"table_tableItem__a2nOR","formControl":"table_formControl__1pFY7"};